import {
  AfterContentInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
@Component({
  selector: 'btn',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    TranslateModule,
  ],
})
export class ButtonComponent implements AfterContentInit {
  public transition = 'transition: none;';

  /**
   * Отвечает за ширину кнопки, на всю ширину контейнера или нет
   */
  @Input() wide: boolean = false;

  /**
   * Отвечает за высоту кнопки
   */
  @Input() thin: boolean = false;

  /**
   * Текст для кнопки, принимает либо обычный текст, либо ключ
   */
  @Input() buttonText!: string;
  @Input() buttonTextParams: Record<string, unknown> = {};

  /**
   * Отображение кнопки в виде синей с синим бордером
   */
  @Input() blueBorder: boolean = false;

  /**
   * Отображение кнопки в виде прозрачной
   */
  @Input() nude: boolean = false;

  /**
   * Отображение кнопки с иконкой и стрелкой
   */
  @Input() selection: boolean = false;

  /**
   * Кнопка в виде ссылки
   */
  @Input() link: boolean = false;

  /**
   * Кнопка для фильтров
   */
  @Input() filter: boolean = false;
  @Input() filterMain: boolean = false;
  @Input() filterStyle: 'vermilion' | 'transparent' = 'vermilion';

  /**
   * Кнопка для фильтров с сеттингс иконкой
   */
  @Input() filterSettings: boolean = false;

  /**
   * Активное состояние
   */
  @Input() active: boolean = false;

  /**
   * Отображение лоадера в кнопке при загрузке
   */
  @Input() loading: boolean = false;

  /**
   * Неактивная кнопка
   */
  @Input() disabled: boolean = false;

  /**
   * Путь до иконки
   */
  @Input() src!: string;

  /**
   * Имя иконки из спрайта
   */
  @Input() iconName!: string;

  /**
   * Ширина иконки из спрайта
   */
  @Input() iconWidth!: string;

  /**
   * Высота иконки из спрайта
   */
  @Input() iconHeight!: string;

  /**
   * Цвет иконки из спрайта
   */
  @Input() iconColor!: string;

  /**
   * Тип кнопки. Стандартные button, submit
   *
   * @type {string}
   * @memberof ButtonComponent
   */
  @Input() type = 'button';

  /**
   *  Дата атрибуты
   */
  @Input() dataAttrs: Record<string, string> = {};

  /**
   *  Дата атрибуты для span
   */
  @Input() spanDataAttrs: Record<string, string> = {};

  @Input() viewBox = '0 0 32 32';

  /**
   * Событие на клик
   */
  @Output() action: EventEmitter<void>;

  constructor(
    private _cdr: ChangeDetectorRef
  ) {
    this.action = new EventEmitter();
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.transition = 'transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;';
      this._cdr.detectChanges()
    });
  }

  public onClick(): void {
    this.action.emit();
  }
}
